import React, { useEffect, useState, Fragment } from "react";
import Loader from "../../UI/loader";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { sendAnalytics } from "../../../action/homeAction";
import { setRegPage } from "../../../action/action";
import { closeOrderPopUp } from "../../action/hCommerce2";
import { setGoHome, setLoginRequired } from "../../action/homeAction";
import { CLICKED, CMSPath, EXIT } from "../../../config/constant";
import { getDefaultAnalyticsLabel } from "../../JS/utility";
import { getSpaTreatmentList } from "../../../action/spaBooking";
import SuccessFailScreen from "../../UI/SuccessFailScreen";
import SpaBooking1 from "./spaBooking1";
import SpaBooking2 from "./spaBooking2";
import SpaBooking3 from "./spaBooking3";
import SpaBookingSuccess from "./spaBookingSuccess";


const SpaBooking = (props) => {

    const { t } = props;

    let room = localStorage.getItem("room");
    let label = getDefaultAnalyticsLabel({ appVersion: props.installedAppVersion ? `${props.installedAppVersion}(${props.installedAppBuildNo})` : "" })
    let widgetSesstionId = localStorage.getItem("spaBookingSessionToken");


    const [error, setError] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");

    const [loading, setLoading] = useState(false);
    const [displayLoadingMsg, setDisplayLoadingMessage] = useState("");

    const [currentPage, setCurrentPage] = useState(null);
    const [displayMyReservation, setDisplayMyReservation] = useState(false);

    const [spaData, setSpaData] = useState([]);
    const [spaLocationId, setSpaLocationId] = useState(null);

    const [serviceGroupData, setServiceGroupData] = useState([]);
    const [serviceData, setServiceData] = useState([]);
    
    const [successResponse,setSuccessResponse]=useState(null);

    useEffect(()=>{
        console.log('Spabooking', props)
        console.log('Spabooking', spaLocationId)
        console.log('Spabooking', spaData)

    })

    // const handleSuccessBooking = () => {
    //     setCurrentPage(1);
    // }

    const handleServiceNextScreen2 = (serviceData) => {
        setServiceData(serviceData);
        setCurrentPage(3);
    }

    const handleLocationNextScreen1 = (spaLocationId) => {
        setSpaLocationId(spaLocationId);

        spaData.forEach((data) => {
            if(data.spalocationId == spaLocationId){
                setServiceGroupData(data.serviceGroup)
            }
        })
        setCurrentPage(2);
    }

    const handleGoBack = () => {
        if (currentPage == 3) {
            setCurrentPage(2)
            return;
        }

        if (currentPage == 2) {
            if (spaData.length == 1) {
                props.setGoHome(true);
            } else {
                setCurrentPage(1);
            }
            return;
        }

        props.setGoHome(true);
    }

    const fetchSpaTreatmentList = () => {

        setError(false);
        setLoading(true);

        getSpaTreatmentList(spaLocationId)
            .then((res) => {
                if (res.status == 200) {
                    setSpaData(res.data.payload.data);
                    setCurrentPage(1)
                    setLoading(false);

                    props.sendAnalytics(
                        props.guestDetail,
                        props.currentWidgets.widgetType,
                        "FETCH SPA DATA - SUCCESS",
                        { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": widgetSesstionId },
                        0,
                        props.guestIsLoggedIn
                    );
                } else {
                    setLoading(false);
                    setError(true)
                    setErrorMsg(res.response && res.response.data.header && res.response.data.header.status && res.response.data.header.status.msg)


                    props.sendAnalytics(
                        props.guestDetail,
                        props.currentWidgets.widgetType,
                        "FETCH SPA DATA - ERROR",
                        { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": widgetSesstionId, "errorStatus": res.response.status, "errorMessage": JSON.stringify(res.response.data.header.status.msg) },
                        0,
                        props.guestIsLoggedIn
                    );
                }
            })
            .catch((err) => { setLoading(false); setError(true) })
    }


    const fetchData = async () => {
        if (room && room != "null") {
            fetchSpaTreatmentList();
        } else {
            if (process.env.REACT_APP_INROOMTAB == "true") {
                props.setLoginRequired(true)
            } else {
                props.setRegPage(true);
            }
        }
    };

    const handleReservationSuccess=(res)=>{
        setSuccessResponse(res)
        setCurrentPage(4);
    }



    useEffect(() => {
        if (!loading) setDisplayLoadingMessage("");
    }, [loading])


    useEffect(() => {

        // If the widget is for the "Spa location," then set the spaLocationId to fetch data corresponding to that location.
        if (props.currentWidgets.spaLocationId) setSpaLocationId(props.currentWidgets.spaLocationId);

        console.log(props.currentWidgets, 'currentWidgts@')
        console.log('room?',room)
        fetchData();

        if(!localStorage.getItem("spaBookingClicked")){
            props.sendAnalytics(
                props.guestDetail,
                props.currentWidgets.widgetType,
                CLICKED,
                { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": widgetSesstionId },
                0,
                props.guestIsLoggedIn,
                () => localStorage.setItem("spaBookingClicked", true)
            );
        }

        return () => {
            props.sendAnalytics(
                props.guestDetail,
                props.currentWidgets.widgetType,
                EXIT,
                { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": widgetSesstionId },
                0,
                props.guestIsLoggedIn
            );

        }
    }, [])
    
    useEffect(()=>{
         console.log("current Page", currentPage)
    })


    return (
        <Fragment>
            <header className="inner-pages w-footer subpages">
                <a className="button-back" onClick={() => handleGoBack()}></a>
                <div className="heading align-center">
                    <div class="splash-brand">
                        <img src={`${CMSPath}${props.logo}`} />
                    </div>
                </div>
            </header>
            <section className="widgets padding-0 margin-0 container-bg">

                {error ?
                    <SuccessFailScreen status={false} showTryAgain={true} showClose={true} statusMessage1={t(`spaBooking.errors.error`)} statusMessage2={errorMsg || t('spaBooking.errors.unable_process_request')} close={props.setGoHome} tryAgain={() => fetchData()} />
                    :
                    currentPage == 1 ?
                        <SpaBooking1 spaData={spaData} next={(spaLocationId) => handleLocationNextScreen1(spaLocationId)} goBack={() => handleGoBack()} />
                        :
                    currentPage == 2 ?
                        <SpaBooking2 spaLocationId={spaLocationId} serviceGroupData={serviceGroupData} next={(serviceData) => handleServiceNextScreen2(serviceData)} goBack={() => handleGoBack()}/>
                        :
                    currentPage == 3 ? 
                        <SpaBooking3 spaLocationId={spaLocationId} serviceGroupData={serviceGroupData} serviceData={serviceData}  handleReservationSuccess={handleReservationSuccess} goBack={() => handleGoBack()}/>
                        :
                    currentPage == 4 ? 
                        <SpaBookingSuccess serviceData={serviceData} successResponse={successResponse}  />
                        :
                    null
                }
            </section>
            {loading && <Loader displayMsg={displayLoadingMsg} />}
        </Fragment>
    )
}

const mapStateToProps = state => {
    return {
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        currentHomePage: state.store2.currentHomePage,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        currentWidgets: state.store.sideNavBar.currentWidget,
    }
}

export default connect(mapStateToProps, { setGoHome, closeOrderPopUp, setRegPage, setLoginRequired, sendAnalytics })(withTranslation('translations')(SpaBooking));
